import React, { useContext } from "react";
import { FormBuilderContext, ACTIONS } from "../context/context";
import { FormBuilderSwitch } from "../components/Switch";
import InputSection from "../components/InputSection";
import ColorPickerInput from "../components/ColorPickerInput";
import CustomSelect from "../components/CustomSelect";
import FontFamilySelect from "../components/FontFamilySelect";

const SelectGroup = () => {
  const { state, dispatch } = useContext(FormBuilderContext);

  const handleColorChange = (actionType) => (color) => {
    dispatch({ type: actionType, payload: color });
  };

  const handleFontWeightChange = (event) => {
    dispatch({
      type: ACTIONS.SELECT_FONT_WEIGHT_INPUT,
      payload: event.target.value,
    });
  };

  const handleselectWidthUnitsChange = (event) => {
    dispatch({
      type: ACTIONS.SELECT_WIDTH_UNITS,
      payload: event.target.value,
    });
  };

  const handleFontFamilyChange = (event) => {
    dispatch({
      type: ACTIONS.SELECT_FONT_FAMILY_CHANGE,
      payload: event.target.value,
    });
  };

  const handleToggleSelectBackgroundImage = (event) => {
    dispatch({
      type: ACTIONS.SELECT_TOGGLE_BACKGROUND_IMAGE,
      payload: event.target.checked,
    });
  };

  return (
    <>
      <div className="input-group-wrapper">
        {/* ################################################################################ */}

        <InputSection
          id="selectTopSpacing"
          title="Spacing above"
          value={state.selectTopSpacing}
          actionTypeIncrement={ACTIONS.SELECT_TOP_SPACING_INCREMENT}
          actionTypeDecrement={ACTIONS.SELECT_TOP_SPACING_DECREMENT}
          actionTypeInput={ACTIONS.SELECT_TOP_SPACING_INPUT}
          dispatch={dispatch}
        />

        <InputSection
          id="selectPaddingInline"
          title="Inline padding"
          value={state.selectPaddingInline}
          actionTypeIncrement={ACTIONS.SELECT_INLINE_PADDING_INCREMENT}
          actionTypeDecrement={ACTIONS.SELECT_INLINE_PADDING_DECREMENT}
          actionTypeInput={ACTIONS.SELECT_INLINE_PADDING_INPUT}
          dispatch={dispatch}
        />
      </div>
      <h2 className="section-subheader">Field styles</h2>
      <div className="input-group-wrapper">

        <InputSection
          id="selectHeight"
          title="Select field height"
          value={state.selectHeight}
          actionTypeIncrement={ACTIONS.SELECT_HEIGHT_INCREMENT}
          actionTypeDecrement={ACTIONS.SELECT_HEIGHT_DECREMENT}
          actionTypeInput={ACTIONS.SELECT_HEIGHT_INPUT}
          dispatch={dispatch}
        />

        <InputSection
          id="selectWidth"
          title="Select field width"
          value={state.selectWidth}
          actionTypeIncrement={ACTIONS.SELECT_WIDTH_INCREMENT}
          actionTypeDecrement={ACTIONS.SELECT_WIDTH_DECREMENT}
          actionTypeInput={ACTIONS.SELECT_WIDTH_INPUT}
          dispatch={dispatch}
        />

        <div>
          <p>Width by units</p>
          <CustomSelect
            labelId="width-by-units"
            id="width-by-units"
            selectValue={state.selectWidthUnits}
            selectLabel="Width by units"
            selectOnChange={handleselectWidthUnitsChange}
            menuItems={[
              { value: "%", label: "%" },
              { value: "px", label: "px" },
            ]}
          />
        </div>

      </div>
      <h2 className="section-subheader">Font styles</h2>
      <div className="input-group-wrapper">

        <div className="form-builder-section-div">
          <p>Font Family</p>
          <FontFamilySelect
            selectedFontFamily={state.selectFontFamily}
            onFontFamilyChange={handleFontFamilyChange}
          />
        </div>

        <InputSection
          id="selectFontSize"
          title="Font size"
          value={state.selectFontSize}
          actionTypeIncrement={ACTIONS.SELECT_FONT_SIZE_INCREMENT}
          actionTypeDecrement={ACTIONS.SELECT_FONT_SIZE_DECREMENT}
          actionTypeInput={ACTIONS.SELECT_FONT_SIZE_INPUT}
          dispatch={dispatch}
        />
        <div>
          <p>Font Weight</p>
          <CustomSelect
            labelId="font-weight-select"
            id="font-weight-select"
            selectValue={state.selectFontWeight}
            selectLabel="Font Weight"
            selectOnChange={handleFontWeightChange}
            menuItems={[
              { value: 100, label: "100" },
              { value: 200, label: "200" },
              { value: 300, label: "300" },
              { value: 400, label: "400" },
              { value: 500, label: "500" },
              { value: 600, label: "600" },
              { value: 700, label: "700" },
              { value: 800, label: "800" },
              { value: 900, label: "900" },
            ]}
          />
        </div>
      </div>
      <h2 className="section-subheader">Border styles </h2>
      <div className="form-builder-section-div-checkmark">
        <input
          type="checkbox"
          checked={state.selectBorderStyleCheckbox === "none"}
          onChange={() => dispatch({ type: ACTIONS.SELECT_TOGGLE_BORDER_STYLE })}
        />
        <p>Border bottom only?</p>
      </div>
      <div className="input-group-wrapper">
        <div className="form-builder-section-div">
          <p>Border Color</p>
          <ColorPickerInput
            color={state.selectBorderColor}
            onChange={handleColorChange(ACTIONS.SELECT_BORDER_COLOR_INPUT)}
          />
        </div>
        <InputSection
          id="selectBorderWidth"
          title="Border width"
          value={state.selectBorderWidth}
          actionTypeIncrement={ACTIONS.SELECT_BORDER_WIDTH_INCREMENT}
          actionTypeDecrement={ACTIONS.SELECT_BORDER_WIDTH_DECREMENT}
          actionTypeInput={ACTIONS.SELECT_BORDER_WIDTH_INPUT}
          dispatch={dispatch}
        />

        {/* ################################################################################ */}

        <InputSection
          id="selectBorderRadius"
          title="Border radius"
          value={state.selectBorderRadius}
          actionTypeIncrement={ACTIONS.SELECT_BORDER_RADIUS_INCREMENT}
          actionTypeDecrement={ACTIONS.SELECT_BORDER_RADIUS_DECREMENT}
          actionTypeInput={ACTIONS.SELECT_BORDER_RADIUS_INPUT}
          dispatch={dispatch}
        />
      </div>
      {/* ################################################################################ */}
      <h2 className="section-subheader">Color styles </h2>
      <div className="input-group-wrapper">
        <div className="form-builder-section-div">
          <p>Text Color</p>
          <ColorPickerInput
            color={state.selectColor}
            onChange={handleColorChange(ACTIONS.SELECT_COLOR_INPUT)}
          />
        </div>

        <div className="form-builder-section-div">
          <p>Background Color</p>
          <ColorPickerInput
            color={state.selectBackgroundColor}
            onChange={handleColorChange(ACTIONS.SELECT_BACKGROUND_INPUT)}
          />
        </div>
      </div>
      {/* ################################################################################ */}

      {/* ################################################################################ */}

      <h2 className="section-subheader">Hover styles </h2>
      <div className="input-group-wrapper">
        <div className="form-builder-section-div">
          <p>Text Color</p>
          <ColorPickerInput
            color={state.selectHoverColor}
            onChange={handleColorChange(ACTIONS.SELECT_HOVER_COLOR_INPUT)}
          />
        </div>

        {/* ################################################################################ */}

        <div className="form-builder-section-div">
          <p>Border Color</p>
          <ColorPickerInput
            color={state.selectHoverBorderColor}
            onChange={handleColorChange(ACTIONS.SELECT_HOVER_BORDER_COLOR_INPUT)}
          />
        </div>

        {/* ################################################################################ */}

        <div className="form-builder-section-div">
          <p>Background Color</p>
          <ColorPickerInput
            color={state.selectHoverBackgroundColor}
            onChange={handleColorChange(ACTIONS.SELECT_HOVER_BACKGROUND_INPUT)}
          />
        </div>
      </div>

      {/* ################################################################################ */}
      
      <div>
        <div>
          <div>
            <p>Add background image?</p>
            <FormBuilderSwitch
              checked={state.addSelectBackgroundImage}
              onChange={handleToggleSelectBackgroundImage}
            />
          </div>
          {state.addSelectBackgroundImage && (
            <>
              <h2 className="section-subheader">Background image styles</h2>
              <div className="input-group-wrapper">
                <div className="form-builder-section-div">
                  <p>Background image url</p>
                  <div className="input-div">
                    <input
                      type="text"
                      id="selectBackgroundImage"
                      value={state.selectBackgroundImage}
                      onChange={(e) =>
                        dispatch({
                          type: ACTIONS.SELECT_BACKGROUND_IMAGE_INPUT,
                          payload: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <InputSection
                  id="selectImageSize"
                  title="Image Size"
                  value={state.selectBackgroundImageSize}
                  actionTypeIncrement={ACTIONS.SELECT_BACKGROUND_IMAGE_SIZE_INCREMENT}
                  actionTypeDecrement={ACTIONS.SELECT_BACKGROUND_IMAGE_SIZE_DECREMENT}
                  actionTypeInput={ACTIONS.SELECT_BACKGROUND_IMAGE_SIZE_INPUT}
                  dispatch={dispatch}
                />
                <InputSection
                  id="selecttImagePOsitionRight"
                  title="Image Padding Right"
                  value={state.selectBackgroundImagePositionRight}
                  actionTypeIncrement={ACTIONS.SELECT_BACKGROUND_IMAGE_POSITION_RIGHT_INCREMENT}
                  actionTypeDecrement={ACTIONS.SELECT_BACKGROUND_IMAGE_POSITION_RIGHT_DECREMENT}
                  actionTypeInput={ACTIONS.SELECT_BACKGROUND_IMAGE_POSITION_RIGHT_INPUT}
                  dispatch={dispatch}
                />
              </div>
            </>
          )}

        </div>





        {/* ################################################################################ */}
      </div>
    </>
  );
};

export default SelectGroup;
